import { FlickeringGrid } from "shared/ui/magicui/flickering-grid";
import { useViewportSize } from "shared/lib/hooks/use-viewport-size";
import { useDialerGlobalContext } from "@/hooks/dialer/use-dialer-global-context";
import { clsxMerge } from "shared/lib/helpers/styles";

export const NavigationBlockingBackground = () => {
  const { vw } = useViewportSize();

  const { isEnabled: isDialerActive } = useDialerGlobalContext();

  if (!isDialerActive) return null;

  return (
    <div
      className={clsxMerge(
        "absolute z-[1000] h-[64px] w-full",
        "animate-fadein duration-1000",
        "overflow-hidden bg-black/90"
      )}
    >
      <FlickeringGrid
        className="absolute inset-0 z-0 size-full"
        squareSize={4}
        gridGap={6}
        color="#6B7280"
        maxOpacity={0.5}
        flickerChance={0.3}
        height={64}
        width={vw}
      />
    </div>
  );
};
